export class SchedulerCalendarConfiguration implements ng.IServiceProvider {
  enableCalendar: boolean = true;

  configure(config: any): void {
    this.enableCalendar = !!config.enableCalendar;
  }

  $get() {
    return {
      enableCalendar: this.enableCalendar
    };
  }
}

angular.module('capability-ng-scheduler').provider('schedulerCalendarConfiguration', SchedulerCalendarConfiguration);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/config/calendar_configuration.ts